import { get, post } from "@insite/client-framework/Services/ApiService";
import {BaseModel, GetProductAccessoriesApiParameter } from "@insite/client-framework/Types/ApiModels";
import { ApiParameter } from "@insite/client-framework/Services/ApiService";
import { ProductModel } from "@insite/client-framework/Types/ApiModels";

export interface ProductAccessoriesModel {
    productAccessories: any[];
    productERPNumber: string;
    properties: any;
}


export interface GetProductAccessoriesModel extends BaseModel {
    productAccessoriesObj: ProductAccessoriesModel
}


const productAccessoriesUrl = 'api/v1/ProductAccessories/GetAccessories'; // /api/v1/ProductAccessories/GetAccessories?erpNumber=ZX-280535
const productsUrl = "/api/v3/adiglobalproducts";


export async function getProductAccessories(getProductAccessoriesParameter: GetProductAccessoriesApiParameter) {
    const result = await get<GetProductAccessoriesModel>(productAccessoriesUrl, getProductAccessoriesParameter, {erpNumber: getProductAccessoriesParameter.erpNumber});
    return {
        result: result,
        isLoading: false,
    }
}

export function getProductByIdQucikSearch(parameter: any) {
    return get<ProductModel>(`${productsUrl}/${parameter.id}`, {
        expand: parameter.expand,
        additionalExpands: parameter.additionalExpands,
        unitOfMeasure: parameter.unitOfMeasure,
        includeAttributes: parameter.includeAttributes,
        alsoPurchasedMaxResults: parameter.alsoPurchasedMaxResults,
    } as ApiParameter);
}